<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html{height: 100%;}
body{margin: 0;height: 100%;}
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
a{color:#999;}
a:hover,
a:visited,
a:link,
a:active {
    text-decoration: none!important;

}
 .el-footer {
    background-color: #fff;
    color: #333;
    text-align: center;
    line-height: 60px;
  }

#logo{text-align: center;color: #67C23A}
.el-aside{height: 100%;}
.el-container{height: 100%;}
.el-main {
  background-color: #E9EEF3;
  color: #333;
  
}
  .el-menu{height: 100%;}
.is-active a{color:#67C23A;}
.el-pagination{text-align: center;padding: 10px 0; }
.el-pagination.is-background .el-pager li:not(.disabled).active {background-color: #67C23A}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover{color:#fff;}
.el-pagination.is-background .el-pager li:not(.disabled):hover {color:#67C23A}


.el-container::-webkit-scrollbar{
    width: 10px;
   
    background-color: #f5f5f5;
}
/*定义滚动条的轨道，内阴影及圆角*/
.el-container::-webkit-scrollbar-track{
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    border-radius: 10px;
    background-color: #f5f5f5;
}
/*定义滑块，内阴影及圆角*/
.el-container::-webkit-scrollbar-thumb{
    /*width: 10px;*/
    height: 20px;
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #bfc8d8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue